import {defaultVal, isMeaningful, isMeaningless} from "@/utils/common";

/**
 * table列配置，根据传入的columns配置项，计算最终table组件渲染的columns配置项（enhancedColumns）
 * 配置表:
 *  copyable: 是否可复制
 *
 *  扩展配置表:
 *  colgroup: 是否为列组
 *  col: 是否为列
 * @type {{computed: {enhancedColumns(): computed.columns}, props: {columns: {type: ArrayConstructor, required: boolean}}}}
 */
export const columnsMixin = {
  props: {
    columns: {
      type: Array,
      required: true
    },
  },
  computed: {
    enhancedColumns() {
      return this.preprocessColumns(this.columns, true);
    }
  },
  watch: {
    enhancedColumns() {
      if (this.hasTab) {
        this.$refs?.tab?.handleChange();
      }
    }
  },
  methods: {
    /**
     * 预处理column，计算相关属性
     * @param columns
     * @param first 是否为第一列，仅在第一列设置tree config
     */
    preprocessColumns(columns, first) {
      return columns
        .map((column, index) => {
          // 是否为colgroup配置
          const colgroup = this.colgroup(column);
          // 是否为col配置
          const col = this.col(column);

          if (col) {
            return this.colConfig(column, first && index === 0);
          } else if (colgroup) {
            return this.colgroupConfig(column, first && index === 0);
          }
          return null;
        })
        .filter(config => 
          config != null &&
          (this.hasTab ? config.field : true)
        );
    },
    // column 配置
    colConfig(column, first) {
      // content
      const slot = this.decorated(column.field, 'slot');
      const option = this.decorated(column.field, 'option');
      const picture = this.decorated(column.field, 'picture');
      // 获取原始域
      let originField;
      if (slot || option || picture) {
        originField = this.originField(column.field);
      } else {
        originField = column.field;
      }
      // option类型
      const optionType = option ? this.decoratorArg(column.field, 'option') : null;

      return {
        ...column,
        ex: {
          id: column.id,
          // 是否为colgroup配置
          colgroup: false,
          // 是否为col配置
          col: true,
          // 下面先针对col进行优化，之后对colgroup进行优化时，记得考虑
          treeNode: first && isMeaningful(this.treeConfig) && !this.indexTreeNode,
          // header配置
          header: this.colHeaderConfig(column),
          // originField
          originField,
          // slot
          slot,
          slotField: originField,
          // option
          option,
          optionBadge: optionType === 'badge',
          optionTag: optionType === 'tag',
          optionPlain: optionType === 'plain',
          // picture
          picture,
          pictureField: originField,
          // amount
          amount: column.prefix === 'currencySymbol' || column.amount,
          // formatter
          formatter: column.formatter || this.formatter,
          // 动态组件
          activeComp:column.activeComp || null
        },
      }
    },
    // column group 配置
    colgroupConfig(column, first) {
      const colgroupConfig = {
        ...column,
        ex: {
          colgroup: true,
          col: false,
          header: this.colHeaderConfig(column),
          children: this.preprocessColumns(column.children, first)
        }
      };
      // 设置colgroup的id
      colgroupConfig.ex.id = `${column.id}${colgroupConfig.ex.children.map(child => child.id).join('')}`;

      return colgroupConfig;
    },
    // column header配置
    colHeaderConfig(column) {
      // header
      const headerSlot = this.decorated(column.header, 'slot');
      return {
        slot: headerSlot,
        slotField: headerSlot ? `header:${this.originField(column.header, true)}` : null
      }
    },
    // 是否为col
    col(column) {
      return isMeaningless(column.children)
        && this.show(column)
        && (isMeaningless(column.permission) || this.$permission(column.permission))
        && (isMeaningless(column.exist) || column.exist);
    },
    // 是否为colgroup
    colgroup(column) {
      return this.isShowChildren(column)
        && (isMeaningless(column.permission) || this.$permission(column.permission));
    },
    // 直接复制未修改
    isShowChildren(column) {
      if (column.children && column.children.length > 0) {
        return column.children.filter(v => defaultVal(v.checked, true)).length > 0;
      }
      return false;
    },
    show(column) {
      return defaultVal(column.checked, true);
    },
    permissionShow(column) {
      return this.show(column) && (isMeaningless(column.permission) || this.$permission(column.permission));
    },
    decorated(field, decorator) {
      return field && new RegExp(`^.*${decorator}(\\((.*)\\))?:.*$`).test(field);
    },
    decoratorArg(field, decorator) {
      if (field) {
        return field.match(new RegExp(`^.*${decorator}(\\((.*)\\))?:.*$`))[2];
      }
      return null;
    },
    originField(field, header = false) {
      const arr = field.split(":");
      if (header) {
        return arr[1];
      }
      return arr[arr.length - 1];
    },
  }
};





